import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CanActivate } from '@angular/router/src/utils/preactivation';
import { SieniService } from './sieni.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;

  constructor(private _globalService: SieniService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this._globalService.isLoggedIn()) {
      // En el caso de estar autenticado no poder acceder a los components establecidos
      this.router.navigate(['/auth','login']);
      return false;
    } else {
      // en en caso de no estar autenticado perimte la entrada a los component necesarios
      return true;
    }
    
  }
  
}

